export default "__VITE_ASSET__D8666z$8__"